import type { ReturnRequestStatusDto } from "@babackapp/private-api-client";
import type { ReturnMethodKind } from "./resolve-return-method";

export type Stage = {
  key: keyof ReturnRequestStatusDto;
  translationKey: string;
  /** Wording for a store drop-off, kept in step with the status alert's title. */
  storeTranslationKey?: string;
};

// translationKey is resolved dynamically (t(entry.translationKey) in
// return-status-timeline.tsx), invisible to the scanner's static t("...") regex.
// @widget-key: returnRequests.details.timeline.created confirmation
// @widget-key: returnRequests.details.timeline.partiallyTreatedLogistician confirmation
// @widget-key: returnRequests.details.timeline.treatedLogistician confirmation
// @widget-key: returnRequests.details.timeline.partiallyTreatedMerchant confirmation
// @widget-key: returnRequests.details.timeline.treatedMerchant confirmation
// @widget-key: returnRequests.details.timeline.error confirmation
// @widget-key: returnRequests.details.timeline.approvedStore confirmation
export const STAGES: Stage[] = [
  { key: "created", translationKey: "returnRequests.details.timeline.created" },
  { key: "waiting", translationKey: "returnRequests.details.timeline.waiting" },
  {
    key: "approved",
    translationKey: "returnRequests.details.timeline.approved",
    storeTranslationKey: "returnRequests.details.timeline.approvedStore",
  },
  { key: "shipping", translationKey: "returnRequests.details.timeline.shipping" },
  { key: "shipped", translationKey: "returnRequests.details.timeline.shipped" },
  { key: "partiallyTreatedLogistician", translationKey: "returnRequests.details.timeline.partiallyTreatedLogistician" },
  { key: "treatedLogistician", translationKey: "returnRequests.details.timeline.treatedLogistician" },
  { key: "partiallyTreatedMerchant", translationKey: "returnRequests.details.timeline.partiallyTreatedMerchant" },
  { key: "treatedMerchant", translationKey: "returnRequests.details.timeline.treatedMerchant" },
  { key: "resolved", translationKey: "returnRequests.details.timeline.resolved" },
  { key: "cancelled", translationKey: "returnRequests.details.timeline.cancelled" },
  { key: "error", translationKey: "returnRequests.details.timeline.error" },
];

export type TimelineEntry = {
  key: keyof ReturnRequestStatusDto;
  translationKey: string;
  stageIndex: number;
  doneAt: number;
};

export function resolveTimelineEntries(
  status: ReturnRequestStatusDto,
  methodKind: ReturnMethodKind,
): TimelineEntry[] {
  return STAGES.map(({ storeTranslationKey, ...s }, stageIndex) => ({
    ...s,
    translationKey:
      methodKind === "store" && storeTranslationKey ? storeTranslationKey : s.translationKey,
    stageIndex,
    doneAt: status[s.key].doneAt,
    isDone: status[s.key].done,
  }))
    .filter((s) => s.isDone)
    .sort((a, b) => b.doneAt - a.doneAt || b.stageIndex - a.stageIndex)
    .map(({ isDone: _isDone, ...e }) => e);
}
